import { render, staticRenderFns } from "./FilterTermCompare.vue?vue&type=template&id=94c78dd2&scoped=true&"
import script from "./FilterTermCompare.vue?vue&type=script&lang=js&"
export * from "./FilterTermCompare.vue?vue&type=script&lang=js&"
import style0 from "./FilterTermCompare.vue?vue&type=style&index=0&id=94c78dd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c78dd2",
  null
  
)

export default component.exports